
import { React, useEffect, useState, useRef } from 'react'
import { motion } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import PortalComponents from '../../components/PortalComponents/PortalComponents';
import { Button, Checkbox } from "@nextui-org/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft,faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import '../CustomerPortal.css';
import DropFileInput from '../../components/DragAndDrop/components/drop-file-input/DropFileInput';
import ContactChange from './ContactChange';
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter,useDisclosure} from "@nextui-org/react";
import { Toast } from 'primereact/toast';

export const UserDetailsChange = ({ formik, selectedData ,req_count,UserDetailAlt,policy_number}) => {
    const toast = useRef(null);
    const [contactNumber ,setContactNumber]= useState(formik.values.policy_mobile.oldMobile)
    const {isOpen, onOpen, onClose} = useDisclosure();
    const [verified, setVerified] = useState(false);
    const [countdown, Setcountdown] = useState(0);
    const [proofDocError, setProofDocError] = useState(null);
    function onClickRequest(){
        const currentVals = formik.values;
        const oldVals = selectedData;
        
        formik.validateForm().then(async (errors) => {      

            if (Object.keys(errors).length === 0&&proofDocError==null ) {


                if(currentVals?.policy_fullname !=oldVals?.policy_fullname ){
                    UserDetailAlt("policy_fullname")
        
                }
                if( currentVals?.policy_nic != oldVals?.policy_nic  ){
                    UserDetailAlt("policy_nic")
        
                }
                if( currentVals?.policy_address1!=oldVals?.policy_address1||currentVals?.policy_address2!=oldVals?.policy_address2 ||  currentVals?.policy_address3!=oldVals?.policy_address3||currentVals?.policy_address4!=oldVals?.policy_address4 ){
                    UserDetailAlt("policy_address")
        
                }
                if(currentVals?.policy_mobile.oldMobile!=contactNumber){
                    UserDetailAlt("policy_mobile")
                }
            }
        else{
            toast.current.clear();
            toast.current.show({
              severity: 'error',
              summary: 'Invalid or missing Information',
    
              life: 3000,
              sticky: false,
              content: (props) => (
                <div className="p-3" style={{ flex: '1' }}>
                  <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                  <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
                </div>
              ),
            });
        }
        }
            
            
            
            )
      
    }

  
    function CheckProofErrors() {
        // Get current and old values
        const currentVals = formik.values;
        const oldVals = selectedData;
      
       
        if (
           ( currentVals?.policy_fullname !=oldVals?.policy_fullname ||
            currentVals?.policy_nic != oldVals?.policy_nic   ||
            currentVals?.policy_address1!=oldVals?.policy_address1||
            currentVals?.policy_address2!=oldVals?.policy_address2||
            currentVals?.policy_address3!=oldVals?.policy_address3||
            currentVals?.policy_address4!=oldVals?.policy_address4 ) &&
            currentVals.policy_proofdoc.length==0

        ) {
           
            
            setProofDocError( "*Required");
        } else {
 
           
            setProofDocError(null)
        }
    }
    
   
    useEffect(() => {
        CheckProofErrors();
    }, [formik.values, selectedData]); 
    
    return (
        <div style={{padding:10}}>
              <Toast ref={toast} position="top-center" />
            <Modal
                size='4xl'
                isOpen={isOpen}
                onClose={onClose}
            >
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1">Change Contact Info</ModalHeader>
                            <ModalBody>
                                <ContactChange
                                    formik={formik}

                                    UserDetailAlt={UserDetailAlt}
                                    policy_number={policy_number}
                                    verified={verified}
                                    setVerified={setVerified}
                                    countdown={countdown}
                                    Setcountdown={Setcountdown}


                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" variant="light" onPress={onClose}>
                                    Close
                                </Button>
                                <Button color="primary" onPress={()=>{
                                    setContactNumber(formik.values.policy_mobile.newMobile)
                                    onClose();

                                }}
                                isDisabled={!verified}
                                >

                                    Submit
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>
            <Row style={{margin:0}}>
            <h1 style={{fontSize:"20px", fontWeight:"bold" ,textAlign:"center", marginBottom:"20px"}}>USER DETAILS</h1>
                <Col xs={6}>


                    <PortalComponents
                        type={"input-name"}
                        formik={formik}
                        label={"Full Name"}
                        name={`policy_fullname`}
                        value={formik.values.policy_fullname}
                        onchange={formik.handleChange}
                        errors={formik.errors.policy_fullname}

                    />
                </Col>
                <Col xs={6}>
                    <PortalComponents
                        type={"input-nic"}
                        label={"NIC"}
                        formik={formik}
                        name={`policy_nic`}
                        value={formik.values.policy_nic}
                        onchange={formik.handleChange}
                        errors={formik.errors.policy_nic}


                    />
                </Col>
            </Row>
            <Row style={{margin:0}}>
                <Col xs={6}>
                    <PortalComponents
                        type={"input-address"}
                        label={"Address 1"}
                        formik={formik}
                        name={`policy_address1`}
                        value={formik.values?.policy_address1}
                        onchange={formik.handleChange}
                        errors={formik.errors?.policy_address1}

                    />
                    <PortalComponents
                        type={"input-address"}
                        label={"Address 3"}
                        formik={formik}
                        name={`policy_address3`}
                        value={formik.values?.policy_address3}
                        onchange={formik.handleChange}
                        errors={formik.errors?.policy_address3}

                    />

                </Col>
                <Col xs={6}>
                    <PortalComponents
                        type={"input-address"}
                        label={"Address 2"}
                        formik={formik}
                        name={`policy_address2`}
                        value={formik.values?.policy_address2}
                        onchange={formik.handleChange}
                        errors={formik.errors?.policy_address2}

                    />
                    <PortalComponents
                        type={"input-address"}
                        label={"Address 4"}
                        formik={formik}
                        name={`policy_address4`}
                        value={formik.values?.policy_address4}
                        onchange={formik.handleChange}
                        errors={formik.errors?.policy_address4}
                        

                    />

                </Col>
            </Row>
            <Row style={{margin:0}}>
          <Col xs={6}>

            <PortalComponents
                            type={"input"}
                            label={"Proof Description - Please describe what you requested.."}
                            formik={formik}
                            name={`proof_description`}
                            value={formik.values?.proof_description}
                            onchange={formik.handleChange}
                            errors={formik.errors?.proof_description}

                        />

        </Col>

        <Col xs={6}>
          <PortalComponents
                        type={"input-number-group"}
                        label={"Contact number"}  
                        value={contactNumber}
                        onchange={setContactNumber}
                        readOnly={true}
                        endContent={
                            <div className='d-flex align-items-center'>
                                <Button isIconOnly={true} onClick={() => {                                  
                                    Setcountdown(0)
                                    setVerified(false);
                                    onOpen()  
                                    formik.setFieldValue("policy_mobile[newMobile]","")}}>
                                    <FontAwesomeIcon icon={faPenToSquare} color='black' />
                                </Button>
                            </div>
                        }


                    />
          </Col>
           </Row>
            <Row style={{margin:0}}>
                <DropFileInput values={formik.values} setFieldValue={formik.setFieldValue} error={proofDocError} formik_location={"policy_proofdoc"} />
            </Row>
            <Row style={{ width: "100%" }} className='d-flex justify-content-center'>
                <Col lg={3} sm={12} md={3} xs={12}   className='my-4 d-flex justify-content-center '>

                    {req_count && req_count > 0 ?
                        <Button
                            onClick={() => { onClickRequest();}}
                            color='warning' variant="solid"
                            style={{ color: "white" }}
                            isDisabled
                        >
                            Request Pending
                        </Button> :
                        <Button
                           
                            onClick={() => { onClickRequest();}}
                            color='primary' variant="solid"
                            style={{ color: "white" }}
                        >
                            Request Change
                        </Button>
                    }




                </Col>
            </Row>

        </div>

    )
}
